import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export default function gradientObjToCssString(gradientObj) {
  if (!gradientObj) return "";

  var newColorStops = _toConsumableArray(gradientObj.colorStops).sort(function (a, b) {
    return a.position - b.position;
  });

  function colorToCssGradientComponent(color) {
    return ", ".concat(color.color, " ").concat(color.position, "%");
  }

  return "".concat(gradientObj.type, "-gradient(").concat(gradientObj.type === "linear" ? "".concat(gradientObj.angle, "deg") : "circle at ".concat(gradientObj.positionX, "% ").concat(gradientObj.positionY, "%")).concat(newColorStops.map(function (color) {
    return colorToCssGradientComponent(color);
  }).join(""), ")");
}